/* unplugin-vue-components disabled */import script from "./feedback.vue?vue&type=script&setup=true&lang=js"
export * from "./feedback.vue?vue&type=script&setup=true&lang=js"

import "./feedback.vue?vue&type=style&index=0&id=2d4b6ba0&scoped=true&lang=scss"

import exportComponent from "/Users/admin/Desktop/project/klb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d4b6ba0"]])

export default __exports__